import { cn, FeatureIcon } from "@pharaday/lighthouse";
import Link from "next/link";
import type { ReactNode, SVGProps } from "react";

export type MenuItemProps = {
  className?: string;
  Icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  name: string;
  description: string;
  urlRoot: string;
  enabled?: boolean;
  onClick?: () => void;
};

const MenuItem = ({ className, Icon, name, urlRoot, enabled = true, onClick }: MenuItemProps) => {
  return (
    <Link href={urlRoot} onClick={onClick}>
      <button
        disabled={!enabled}
        className={cn("group relative flex w-full flex-col items-center gap-2 truncate", className)}
      >
        <FeatureIcon
          size="lg"
          variant="light-square-primary"
          className={cn(enabled && "group-hover:bg-primary-90", !enabled && "bg-neutral-90 text-neutral-50")}
        >
          <Icon />
        </FeatureIcon>

        <h3 className="w-full truncate text-sm font-bold text-neutral-30 group-disabled:text-neutral-50">{name}</h3>
      </button>
    </Link>
  );
};

export default MenuItem;
